import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { SystemMessageWithType } from '@connect-x-app/shared-view-models';
import { Row } from '@tanstack/react-table';

import { TableLayout } from '../../../../../../shared';
import { useSystemMessageTable } from '../../hooks/useSystemMessageTable';
import { SystemMessagesEmptyState } from '../systemMessagesEmptyState/SystemMessagesEmptyState';

type Props = {
  data: SystemMessageWithType[];
  onRowClicked: (selectedSystemMessage: Row<SystemMessageWithType>) => void;
  title: string;
  updatePermission: boolean;
};

export const SystemMessageTableGroup: FC<Props> = ({ data, onRowClicked, title, updatePermission }) => {
  const { t } = useTranslation();

  const table = useSystemMessageTable(data);
  const renderEmptyState = useCallback(
    () => (
      <SystemMessagesEmptyState
        description={t('SYSTEM_MESSAGES.EMPTY_STATE.TITLE')}
        title={t('SYSTEM_MESSAGES.EMPTY_STATE.DESCRIPTION')}
      />
    ),
    [t],
  );

  return (
    <TableLayout
      emptyState={renderEmptyState}
      isCollapsableTable
      onRowClicked={onRowClicked}
      rowClickAllowed={updatePermission}
      table={table}
      titleText={title}
    />
  );
};
